module.exports = __webpack_public_path__ + "media/images/lp/history5-pc-7a5e707fa820fc7dfa31de31c17a7105.jpg";